import API from './api';

export default class Quiz extends API {
  constructor(config = {}) {
    config.path = 'quizzes';

    super(config);
  }

  answers(resource = '', params = {}) {
    return this.get(`${resource}/answers`, params);
  }

  export(resource = '', data = {}, config = {}) {
    return this.post(data, config, `${resource}/export`);
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/request/quiz.js
 **/